import React, { useState } from 'react';
import axios from 'axios';
import { FaSpinner, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { API_URL } from '../components/config';
const PRIMARY = "#002966";
const ACCENT = "#ffc000";

const JobTitleSubmissionPage = () => {
  const [formData, setFormData] = useState({
    job_title_name: '',
    job_title_grade: '',
    job_title_department: '',
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success' | 'error' | null
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setStatus(null);
    setMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    setMessage('');
    try {
      const response = await axios.post(`${API_URL}/jobtitle`, formData);
      setStatus('success');
      setMessage('Job title created successfully: ' + response.data.job_title_name);
      setFormData({
        job_title_name: '',
        job_title_grade: '',
        job_title_department: '',
      });
    } catch (error) {
      setStatus('error');
      setMessage('Failed to create job title. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-gradient-to-br from-[#f6f7fa] to-[#e1e5ec] relative"
      style={{ background: "linear-gradient(120deg, #f6f7fa 0%, #e1e5ec 100%)" }}
    >
      {/* Accent decor */}
      <div className="absolute -top-28 -left-28 w-52 h-52 rounded-full"
        style={{ background: `${ACCENT}22`, filter: "blur(32px)", zIndex: 0 }} />
      <div className="absolute bottom-0 right-0 w-32 h-32 rounded-full"
        style={{ background: `${PRIMARY}18`, filter: "blur(28px)", zIndex: 0 }} />

      <form
        onSubmit={handleSubmit}
        className="relative z-10 w-full max-w-[400px] py-8 px-7 sm:px-10
          rounded-3xl shadow-2xl
          bg-white/70 backdrop-blur-md
          border border-[#dee5f0]"
        style={{
          boxShadow: "0 8px 32px 0 #00296622, 0 1.5px 5px 0 #ffc00044"
        }}
        autoComplete="off"
      >
        <h2
          className="text-2xl font-extrabold text-center mb-6"
          style={{
            color: PRIMARY,
            letterSpacing: '.03em',
            textShadow: '0 2px 14px #00296622'
          }}
        >
          Submit Job Title
        </h2>

        {/* Feedback Messages */}
        {status && (
          <div className={`
              flex items-center gap-2 mb-4 py-2 px-3 rounded text-sm border
              ${status === 'success'
                ? 'text-green-700 bg-[#eafcdf] border-green-300'
                : 'text-[#a00] bg-[#ffc00022] border-[#ffc00066]'}
            `}>
            {status === 'success' ? <FaCheckCircle /> : <FaTimesCircle />}
            {message}
          </div>
        )}

        <div className="mb-4">
          <label className="block font-medium mb-1 text-[#222]">
            Job Title Name
          </label>
          <input
            type="text"
            name="job_title_name"
            value={formData.job_title_name}
            onChange={handleChange}
            required
            className="bg-white/80 border border-[#e0e4ef] rounded-lg px-3 py-2 w-full
              focus:border-[#ffc000] focus:ring-2 focus:ring-[#ffc00033]
              outline-none font-semibold text-[#002966] shadow
              transition-all"
          />
        </div>
        <div className="mb-4">
          <label className="block font-medium mb-1 text-[#222]">
            Job Title Grade
          </label>
          <input
            type="text"
            name="job_title_grade"
            value={formData.job_title_grade}
            onChange={handleChange}
            required
            className="bg-white/80 border border-[#e0e4ef] rounded-lg px-3 py-2 w-full
              focus:border-[#ffc000] focus:ring-2 focus:ring-[#ffc00033]
              outline-none font-semibold text-[#002966] shadow
              transition-all"
          />
        </div>
        <div className="mb-6">
          <label className="block font-medium mb-1 text-[#222]">
            Job Title Department
          </label>
          <input
            type="text"
            name="job_title_department"
            value={formData.job_title_department}
            onChange={handleChange}
            required
            className="bg-white/80 border border-[#e0e4ef] rounded-lg px-3 py-2 w-full
              focus:border-[#ffc000] focus:ring-2 focus:ring-[#ffc00033]
              outline-none font-semibold text-[#002966] shadow
              transition-all"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className={`
            w-full py-3 rounded-xl font-bold text-lg shadow
            transition-all duration-200
            bg-gradient-to-r from-[#ffc000] to-[#ffd652] text-[#002966]
            hover:from-[#ffd652] hover:to-[#ffc000]
            flex items-center justify-center gap-2
            active:scale-95
            ${loading ? "opacity-70 cursor-not-allowed" : ""}
          `}
          style={{
            boxShadow: "0 4px 18px #ffc00033, 0 1.5px 4px #00296622",
            letterSpacing: ".03em"
          }}
        >
          {loading ? <FaSpinner className="animate-spin" /> : "Submit Job Title"}
        </button>
      </form>
    </div>
  );
};

export default JobTitleSubmissionPage;